import type { CardScanData } from '@/modules/Customer/types'

// Editable card data = AI-extracted + user-filled required fields
export interface EditableCard extends CardScanData {
    _id: string
    _filename: string
    _error: string | null
    customer_type: string
    customer_source: string
    customer_sale_followers: number[]
}

export const MAX_FILES = 10
export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB
export const ACCEPTED_TYPES = ['image/jpeg', 'image/png']
